import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "kn-hint hint" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "far fa-life-ring kn-hintIcon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "kn-hintContent" }, {
      title: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.title)), 1)
      ]),
      content: _withCtx(() => [
        _createVNode("div", {
          innerHTML: _ctx.$t(_ctx.hint)
        }, null, 8, ["innerHTML"])
      ]),
      _: 1
    })
  ]))
}